import { TouchableOpacity } from "react-native"
import GoogleIcon from "@/assets/logo/google-icon-for-button.svg"
import { MYLEADS_GOOGLE_SCOPES } from "@/constants/Scopes"
import { useGoogleLogin } from "@react-oauth/google"
import BFText from "@/components/standard/BFText"

export interface AuthGmailButtonProps {
  onSuccess: (code: string | null, redirectUri?: string) => void
  onDismiss: () => void
  disabled: boolean
}

export default function AuthGmailButton({
  onSuccess,
  onDismiss,
  disabled,
}: AuthGmailButtonProps) {
  const onSignIn = useGoogleLogin({
    onSuccess: (codeResponse) => {
      onSuccess(codeResponse?.code, "postmessage")
    },
    onError: (error) => {
      console.error("Connect Failed:", error)
    },
    onNonOAuthError: (error) => {
      console.error("Connect Failed:", error)
    },
    scope: MYLEADS_GOOGLE_SCOPES.join(" "),
    flow: "auth-code",
  })

  return (
    <TouchableOpacity
      testID={"google-sign-in-button"}
      className={`bg-white h-[50px] rounded-[30px] flex flex-row items-center justify-center mb-12 p-4 px-8 ${disabled ? "opacity-20" : "opacity-100"}`}
      onPress={onSignIn}
      disabled={disabled}
    >
      <GoogleIcon width={28} height={29} />
      <BFText className="ml-4">Authorize with Google Account</BFText>
    </TouchableOpacity>
  )
}
